import React, { useEffect } from "react";
import { Link, useParams } from "react-router-dom";
import { experiences } from "../data";
import "./RequestBookingPage.css";

const BOOKING_FORM_URL =
  "https://frontal-firestorm-840.forms.space/request-booking-s425cb";

const RequestBookingPage = () => {
  const { id } = useParams();

  const experience = experiences.find((item) => item.id === id);

  useEffect(() => {
    window.scrollTo({
      top: 0,
      left: 0,
      behavior: "auto",
    });
  }, [id]);

  if (!experience) {
    return (
      <main className="booking-page booking-not-found">
        <section className="booking-not-found-card">
          <p className="booking-eyebrow">Request Booking</p>

          <h1>We couldn’t find that experience.</h1>

          <p>
            The listing may have moved or may no longer be available.
          </p>

          <Link to="/browse" className="booking-primary-button">
            Browse All Options
          </Link>
        </section>
      </main>
    );
  }

  const bookingFormUrl = new URL(BOOKING_FORM_URL);

  bookingFormUrl.searchParams.set(
    "prefill.experienceName",
    experience.name
  );

  bookingFormUrl.searchParams.set(
    "prefill.experienceLocation",
    `${experience.city}, ${experience.state}`
  );

  return (
    <main className="booking-page">
      {/* PAGE INTRO */}
      <section className="booking-page-heading">
        <p className="booking-eyebrow">Request Booking</p>

        <h1>Let’s start planning your team experience.</h1>

        <p>
          Send us a few details about your group and preferred dates.
          Teamward will coordinate the request with the provider and keep
          you updated along the way.
        </p>
      </section>

      {/* BOOKING CONTENT */}
      <section className="booking-layout">
        {/* EXPERIENCE CARD */}
        <aside className="booking-experience-card">
          <Link
            to={`/business/${experience.id}`}
            className="booking-back-link"
          >
            ← Back to experience
          </Link>

          <img
            src={experience.image}
            alt={experience.name}
            className="booking-experience-image"
          />

          <div className="booking-experience-content">
            <p className="booking-location">
              {experience.city}, {experience.state}
            </p>

            <h2>{experience.name}</h2>

            <p className="booking-summary">
              {experience.summary}
            </p>

            <div className="booking-facts">
              <span>{experience.groupSize} people</span>
              <span>{experience.duration}</span>
              <span>{experience.price}</span>
              <span>{experience.setting}</span>
            </div>

            <div className="booking-reminder">
              <strong>This is a booking request.</strong>

              <p>
                Your event is not confirmed until availability, pricing,
                and final details have been approved.
              </p>
            </div>
          </div>
        </aside>

        {/* REQUEST FORM */}
        <section className="booking-form-card">
          <header className="booking-form-header">
            <p className="booking-form-eyebrow">
              Booking Request
            </p>

            <h2>Request {experience.name}</h2>

            <p className="booking-free-note">
              <strong>No fee to submit a request.</strong>{" "}
              Teamward will coordinate with the provider. Once
              availability, pricing, and details are approved, you’ll
              receive the final price and payment instructions.
            </p>
          </header>

          <div className="booking-form-frame">
            <iframe
              src={bookingFormUrl.toString()}
              title={`Request booking for ${experience.name}`}
              className="booking-form-embed"
              frameBorder="0"
              loading="lazy"
            />
          </div>

          <aside className="booking-next-card">
            <span className="booking-next-icon" aria-hidden="true">
              ✓
            </span>

            <div>
              <h3>What happens next?</h3>

              <p>
                Teamward will coordinate your request with the provider
                and keep you updated by email.
              </p>
            </div>
          </aside>
        </section>
      </section>
    </main>
  );
};

export default RequestBookingPage;
